/** ITGC-scope RCM column ids used for show/hide (gear menu). */
export const RCM_ITGC_TABLE_COLUMNS = [
  { id: 'srNo', label: 'Sr. No.', hideable: false },
  { id: 'classification', label: 'Classification', hideable: true },
  { id: 'domain', label: 'Domain', hideable: true },
  { id: 'system', label: 'System', hideable: true },
  { id: 'controlId', label: 'Control ID', hideable: true },
  { id: 'riskId', label: 'Risk ID', hideable: true },
  { id: 'riskDescription', label: 'Risk Description', hideable: true },
  { id: 'controlObjective', label: 'Control Objective', hideable: true },
  { id: 'controlDescription', label: 'Control Description', hideable: true },
  { id: 'controlOwner', label: 'Control Owner', hideable: true },
  { id: 'keyReports', label: 'Key Reports', hideable: true },
  { id: 'frequency', label: 'Frequency', hideable: true },
  { id: 'controlType', label: 'Control Type', hideable: true },
  { id: 'keyNonKey', label: 'Key / Non Key', hideable: true },
];

export function createDefaultRcmItgcColumnVisibility() {
  return Object.fromEntries(RCM_ITGC_TABLE_COLUMNS.map((column) => [column.id, true]));
}

export function isRcmItgcColumnVisible(columnVisibility, columnId) {
  if (!columnId) return false;
  return columnVisibility?.[columnId] !== false;
}

export function getVisibleRcmItgcColumnCount(columnVisibility) {
  return RCM_ITGC_TABLE_COLUMNS.filter((column) => isRcmItgcColumnVisible(columnVisibility, column.id)).length;
}

export function getHideableRcmItgcColumns() {
  return RCM_ITGC_TABLE_COLUMNS.filter((column) => column.hideable !== false);
}

export function getDefaultRcmItgcColumnOrder() {
  return RCM_ITGC_TABLE_COLUMNS.map((column) => column.id);
}

export function mergeRcmItgcHideableOrder(fullOrder, orderedHideableIds) {
  const base = Array.isArray(fullOrder) && fullOrder.length > 0
    ? [...fullOrder]
    : getDefaultRcmItgcColumnOrder();
  const hideableSet = new Set(orderedHideableIds);
  let cursor = 0;
  const next = base.map((id) => {
    if (!hideableSet.has(id)) return id;
    const replacement = orderedHideableIds[cursor];
    cursor += 1;
    return replacement ?? id;
  });
  for (const id of orderedHideableIds) {
    if (!next.includes(id)) next.push(id);
  }
  for (const id of getDefaultRcmItgcColumnOrder()) {
    if (!next.includes(id)) next.push(id);
  }
  return next;
}

export function getOrderedVisibleRcmItgcColumnIds(columnOrder, columnVisibility) {
  const order = Array.isArray(columnOrder) && columnOrder.length > 0
    ? columnOrder
    : getDefaultRcmItgcColumnOrder();
  const known = new Set(RCM_ITGC_TABLE_COLUMNS.map((c) => c.id));
  return order.filter((id) => known.has(id) && isRcmItgcColumnVisible(columnVisibility, id));
}
